var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "app-main-inner-row extension-conditions-form search-areaheader",
      staticStyle: {
        background: "#f5f7f7",
        padding: "5px 16px 0 16px !important"
      }
    },
    [
      _c(
        "el-form",
        { attrs: { inline: "", "label-position": "left" } },
        [
          _c(
            "el-form-item",
            {
              staticClass: "el-form-item-search",
              attrs: { label: _vm.inputDateLabel }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { "margin-right": "0px" },
                            attrs: {
                              type: "date",
                              no: "inputDateStart",
                              clearable: false,
                              "value-format": "yyyy-MM-dd",
                              "picker-options": _vm.pickerOptions,
                              editable: false
                            },
                            model: {
                              value: _vm.searchConditions.inputDateStart,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.searchConditions,
                                  "inputDateStart",
                                  $$v
                                )
                              },
                              expression: "searchConditions.inputDateStart"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 2 } }, [
                    _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v(_vm._s(_vm.$t("WriteOff.dateTo")))
                    ])
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              no: "inputDateEnd",
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              "picker-options": _vm.pickerOptions
                            },
                            model: {
                              value: _vm.searchConditions.inputDateEnd,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.searchConditions,
                                  "inputDateEnd",
                                  $$v
                                )
                              },
                              expression: "searchConditions.inputDateEnd"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "allowTwoYearOutside" },
                              model: {
                                value: _vm.allowTwoYearOutside,
                                callback: function($$v) {
                                  _vm.allowTwoYearOutside = $$v
                                },
                                expression: "allowTwoYearOutside"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Invoice.invoice_queryLotsOfData")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }